import { render, staticRenderFns } from "./Transaction-History.vue?vue&type=template&id=f359dbc2"
import script from "./Transaction-History.vue?vue&type=script&lang=js"
export * from "./Transaction-History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports